"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var kb_actions_enum_1 = require("./kb.actions.enum");
var LoadHierarchicalCategoriesAction = /** @class */ (function () {
    function LoadHierarchicalCategoriesAction(prefix) {
        this.prefix = prefix;
        this.type = kb_actions_enum_1.KbActionTypes.LoadHierarchicalCategories;
    }
    return LoadHierarchicalCategoriesAction;
}());
exports.LoadHierarchicalCategoriesAction = LoadHierarchicalCategoriesAction;
//# sourceMappingURL=load-hierarchical-categories.action.js.map